module.exports = __webpack_public_path__ + "img/kp.3f06f4b2.svg";